module.exports = function getResource(label) {
    let resources = {
        shopNow: 'Shop now',
        video: 'Video'
    };

    return resources[label];
};
